import { ToastUtil } from "utilities/toastUtil";
import { isRejectedWithValue } from "@reduxjs/toolkit";

const errorBlackList = ["refreshToken"];

// Endpoints where a 404 just means "no data for these filters" — the screen
// renders its own empty state, so the global "not found" toast is just noise.
const notFoundOkList = [
  "getRequesterBudget",
  "getBudgetLines",
  "getBudgetLineRows",
  "getBudgetItems",
  // "Check Stock" on an order line — 404 just means no stock row for this
  // item/center yet (= 0 on hand); the row handles it itself.
  "getItemStock",
];

export const apiErrorMiddleware = () => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const { meta, payload } = action;
    const endpoint = meta.arg?.endpointName ?? "";
    if (errorBlackList.includes(endpoint)) {
      return next(action);
    }

    const statusCode = payload?.status;
    if (statusCode === 404) {
      if (!notFoundOkList.includes(endpoint)) {
        ToastUtil.showToastError("Resource not found (404)");
      }
    } else if (statusCode === 500) {
      ToastUtil.showToastError("Internal server error (500)");
    }
  }
  return next(action);
};
